<template>
	<div class="guest-info">
		<div class="guest-info--icon">
			<Icon
				icon-name="tag-general_tagging"
				size="xxl"
			/>
		</div>
		<div class="guest-info--message">
			<p class="title">
				{{ labels.title }}
			</p>
			<p class="body">
				{{ labels.body }}
			</p>
			<p class="footer">
				{{ labels.footer }}
			</p>
		</div>
		<div class="guest-info--button">
			<button
				class="button button--icon"
				@click="onCreateClick"
			>
				<Icon
					icon-name="settings-gear"
					size="sm"
				/>
				<span>{{ transUcfirst('one.create_buttons') }}</span>
			</button>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
	name:     'CustomButtonsInfoPanel',
	computed: {
		labels() {
			return {
				title:  this.transUcfirst('one.tag_center_guest_info.title'),
				body:   this.transUcfirst('one.tag_center_guest_info.description'),
				footer: this.transUcfirst('one.tag_center_guest_info.footer'),
			};
		},
	},
	methods: {
		...mapActions({
			setTaggingToolSettingsOpen: 'app/setTaggingToolSettingsOpen',
		}),
		onCreateClick() {
			this.setTaggingToolSettingsOpen(true);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import "@videotools/sass/_fonts.scss";

.guest-info {
	display: flex;
	flex-direction: column;
	align-items: center;
	color: var(--color-grey-500);
	padding: 74px;

	&--icon {
		margin-bottom: 16px;
	}

	&--message {
		@include text-sm-2;
		margin-bottom: 16px;
		display: flex;
		flex-direction: column;
		align-items: center;

		p {
			text-align: center;
			margin-bottom: 16px;
		}

		.title {
			@include text-md-2;
		}
	}

	&--button {
		button {
			@include text-sm-2;
			line-height: initial;
			padding: 6px 12px;
			color: var(--color-soft-white);
			background-color: var(--color-green-petrol);
			border-color: var(--color-green-petrol);
		}
	}
}
</style>
